import {
  concederAcessoSchema,
  initialValuesFragment,
  mapSubmitValues
} from '../utils/functions'
import { useSnackbar } from '@tecsinapse/cortex-react'
import { ApolloError, useMutation } from '@apollo/client'
import { CONCEDER_ACESSO } from '../data/conceder-acesso'
import { SubmitHandler, useForm } from 'react-hook-form'
import { NovaPastaValues } from './use-nova-pasta-dialog'
import {
  ConcederAcessoMutationMutation,
  ConcederAcessoMutationMutationVariables,
  ItemBiblioteca
} from '@/core/types/graphql'
import { t } from '@lingui/core/macro'
import { zodResolver } from '@hookform/resolvers/zod'

export type ConcederAcessoValues = Omit<NovaPastaValues, 'idPai' | 'nome'>

export const useConcederAcessoDialog = ({
  pastaAtual,
  close
}: {
  pastaAtual: ItemBiblioteca
  close: () => void
}) => {
  const { snackbar } = useSnackbar()

  const [concederAcessoMutation] = useMutation<
    ConcederAcessoMutationMutation,
    ConcederAcessoMutationMutationVariables
  >(CONCEDER_ACESSO)

  const initialValues = initialValuesFragment(pastaAtual)

  const form = useForm<ConcederAcessoValues>({
    values: initialValues,
    resolver: zodResolver(concederAcessoSchema),
    mode: 'onSubmit'
  })

  const onSubmit: SubmitHandler<ConcederAcessoValues> = async values => {
    const { tiposAcesso } = mapSubmitValues(values)

    const novasPermissoes = {
      tiposAcesso,
      idPasta: pastaAtual.id
    }

    try {
      await concederAcessoMutation({
        variables: {
          novasPermissoes
        }
      })

      snackbar.show('success', t`Acesso concedido com sucesso!`)

      form.reset()
      close()
    } catch (error) {
      snackbar.show('error', t`Erro ao conceder acesso`)
      console.error((error as ApolloError).message)
    }
  }

  const closeForm = () => {
    form.reset()
    close()
  }

  return {
    form,
    onSubmit,
    closeForm
  }
}
